<template>
  <div>
    <base-header type="gradient-primary" class="pb-6 pb-7 pt-7 opacity-8">
      <div class="card shadow col-md-12 p-3">
        <div class="d-flex flex-row">
          <div class="p-0 mb-3">
            <div class="col-12 pl-1">
              <b-form-select
                id="input-3"
                v-model="ChartBrandCodeModel"
                :options="brandCodeOption"
                class="mx-input"
                required
              ></b-form-select>
            </div>
          </div>
          <div class="p-0 mb-3">
            <date-picker
              v-model="chartDate"
              range
              confirm-text="confirm"
              confirm
              editable
              clearable
              :default-value="chartDate"
              value-type="YYYY-MM-DD"
              @confirm="onChartDateChanged"
              id="DateRange"
            ></date-picker>
          </div>
        </div>
        <div class="container mb-4">
          <div class="row">
            <div class="card shadow col-3 text-center pt-1">
              <label class="text-sm"> Grand total</label>
              <label class="text-lg">
                {{
                  SummaryData.map((a) => a.count)
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
                <span class="text-sm">(selected date)</span>
              </label>
              <label class="text-lg">
                {{
                  SummaryData[0]
                    ? SummaryData[0].totalItems
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0
                }}
                <span class="text-sm">(all date)</span></label
              >
            </div>
            <div class="card shadow col-3 text-center pt-1">
              <label class="text-sm"> Total transaction</label>
              <label class="text-lg">
                {{
                  SummaryData.map((a) => a.countWin)
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
                <span class="text-sm">(wins)</span>
              </label>
              <label class="text-lg">
                {{
                  SummaryData.map((a) => a.countLoss)
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
                <span class="text-sm">(loss)</span>
              </label>
            </div>
            <div class="card shadow col-3 text-center pt-1">
              <label class="text-sm"> Total credit used</label>
              <label class="text-xl mt-2">
                {{
                  SummaryData.map((a) => a.creditsUsed)
                    .reduce(function (a, b) {
                      return (a ? a : 0) + (b ? b : 0);
                    }, 0)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                }}
                <span class="text-sm">Peso</span>
              </label>
            </div>
            <div class="card shadow col-3 text-center pt-1">
              <label class="text-sm"> Total voucher redeemed</label>
              <label class="text-xl mt-2">
                {{
                  SummaryData.map((a) => a.countSuccessRedeem)
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
                <span class="text-sm">vouchers</span>
              </label>
            </div>
          </div>
        </div>
        <bar-chart :chart-data="chartDataSource"></bar-chart>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-8 col-8 mb-1">
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary ml-2"
            >
              <i class="fa fa-edit"></i> Details
            </button>
            <download-excel
              :data="selectedItems"
              name="giftaway-selected-transaction.csv"
              type="csv"
              style="float: left"
            >
              <button class="btn btn-primary ml-2">
                <i class="fa fa-download"></i>
                Export selected
              </button>
            </download-excel>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="message.type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <div class="accordion p-3" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.accordion-1
                variant="neutral"
                class="text-left"
                >Search Transaction Criteria
                <span class="when-opened ml-3">
                  <i class="fa fa-arrow-down" />
                </span>
                <span class="when-closed ml-3">
                  <i class="fa fa-arrow-right" />
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    brand
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="BrandCodeModel"
                      :options="brandCodeOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    transaction date
                  </label>
                  <div class="col-sm-3">
                    <date-picker
                      v-model="timeFilter"
                      range
                      confirm-text="confirm"
                      confirm
                      editable
                      clearable
                      :default-value="timeFilter"
                      value-type="YYYY-MM-DD"
                      @confirm="onDateFilterSubmit"
                      id="DateRange"
                    ></date-picker>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    query by
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="PropertyFilterModel"
                      :options="PropertyFilterList"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                  <label
                    class="col-form-label form-control-label text-sm pl-0"
                    >{{ ConditionFilterModel }}</label
                  >
                  <div class="col-sm-4 ml-0">
                    <input
                      v-model="ValueFilterModel"
                      class="form-control mx-input"
                    />
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    Product Type
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="ProductTypeModel"
                      :options="productTypeOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mt-3 row">
                  <div class="col-sm-2 col-form-label form-control-label"></div>
                  <button
                    v-on:click="onSearchFilter"
                    class="btn btn-warning ml-3"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                  <button
                    v-on:click="onSearchExport"
                    class="btn btn-warning ml-2"
                  >
                    <i class="fa fa-download"></i> Search and Export
                  </button>
                  <button
                    v-on:click="onResetFilter"
                    class="btn btn-neutral ml-2"
                  >
                    <i class="fa fa-times"></i> reset query
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @on-all-select-rows="onSelectAllRow"
        >
        <template slot="action_button" slot-scope="props">
            <button
              v-on:click="resendorder(props.row.id, props.row.order_id)"
              :disabled="props.row.status == 'REDEEM_FAILED_LOSS' || !is_allowed_resendorder"
              class="btn btn-primary ml-2"
            >
            Resend Order
            </button>
         </template>        
        </vue-bootstrap4-table>
        <div class="overflow-auto mt-3">
          <nav>
            <ul class="pagination b-pagination justify-content-center">
              <li class="col-12 p-0 pl-2">
                <label class="ml-2">Go to page: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="currentPage"
                  :options="arrayPages()"
                  required
                ></b-form-select>
                <b-button
                  v-if="currentPage != 1"
                  v-on:click="onLoadData(currentPage - 1)"
                  class="ml-3 mr-1 btn-sm btn-neutral"
                >
                  <i class="fa fa-less-than"></i>
                </b-button>
                <b-button
                  v-if="currentPage != totalPages"
                  v-on:click="onLoadData(currentPage + 1)"
                  class="ml-1 mr-3 btn-sm btn-neutral"
                >
                  <i class="fa fa-greater-than"></i>
                </b-button>

                <label class="ml-2">Show rows: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="itemPerPage"
                  :options="ItemPerPageList"
                  required
                ></b-form-select>
                <label
                  >{{ itemPerPage * currentPage - itemPerPage + 1 }} -
                  {{
                    currentPage == totalPages
                      ? totalItems
                      : itemPerPage * currentPage
                  }}
                  of {{ totalItems }}
                </label>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <modal :show.sync="showModalCreate" modal-classes="modal-md">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Redeem Transaction
      </h3>
      <table class="table table-striped">
        <tr>
          <td>Brand</td>
          <td>{{ this.productModel.brand_code }}</td>
        </tr>
        <tr>
          <td>Product</td>
          <td>{{ this.productModel.product_id }}</td>
        </tr>
        <tr>
          <td>Product Type</td>
          <td v-if="this.productModel.product_type_id == '1'">Normal Item</td>
          <td v-if="this.productModel.product_type_id == '2'">Bound Item</td>
        </tr>
        <tr>
          <td>Catalog</td>
          <td>{{ this.productModel.catalog_name }}</td>
        </tr>
        <tr>
          <td>Merchant</td>
          <td>{{ this.productModel.merchant_id }}</td>
        </tr>
        <tr>
          <td>Order No</td>
          <td>{{ this.productModel.order_id }}</td>
        </tr>
        <tr>
          <td>Reference No</td>
          <td>{{ this.productModel.reference_no }}</td>
        </tr>
        <tr>
          <td>Win Loss Status</td>
          <td class="green" v-if="this.productModel.winloss_status == 'WIN'">
            {{ this.productModel.winloss_status }}
          </td>
          <td class="red" v-if="this.productModel.winloss_status == 'LOSS'">
            {{ this.productModel.winloss_status }}
          </td>
        </tr>
        <tr>
          <td>User Sitefinity Raffle Id</td>
          <td>{{ this.productModel.sitefinity_user_id }}</td>
        </tr>
        <tr>
          <td>Reward Status</td>
          <td>{{ this.productModel.status }}</td>
        </tr>
        <tr>
          <td>Expired Date</td>
          <td>{{ this.productModel.expiry_date_time }}</td>
        </tr>
        <tr>
          <td>Credit Used</td>
          <td>{{ this.productModel.credits_used }}</td>
        </tr>
        <tr>
          <td>Credit Balance</td>
          <td>{{ this.productModel.credits_balance }}</td>
        </tr>
        <tr>
          <td>Amount Deducted</td>
          <td>{{ this.productModel.deducted_amount }}</td>
        </tr>
        <tr>
          <td>Urls</td>
          <td>{{ this.productModel.urls }}</td>
        </tr>
        <tr>
          <td>Create Date</td>
          <td>{{ this.productModel.create_date }}</td>
        </tr>
        <tr>
          <td>Modify Date</td>
          <td>{{ this.productModel.modify_date }}</td>
        </tr>
        <tr>
          <td>Gift Status</td>
          <td>{{ this.productModel.gift_status }}</td>
        </tr>
      </table>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { API } from "aws-amplify";
import * as queries from "./../graphql/queries";
import "vue2-datepicker/index.css";
import api_loyalty from "../api/api";
import BarChart from "./../components/Charts/BarChart";
import NProgress from "nprogress";
import axios from "axios";

export default {
  name: "configList",
  data() {
    return {
      is_allowed_resendorder: false,
      SummaryData: [],
      chartDate: [],
      chartDataSource: { labels: [], datasets: [] },
      totalItems: 0,
      totalPages: 0,
      isCompletedLoadAllItems: false,
      nextToken: null,
      ListNextToken: [],
      itemPerPage: 50,
      ItemPerPageList: [50, 100, 500, 1000, 5000],
      currentPage: 1,
      IsConditionFilterDisabled: true,
      BrandCodeModel: "PHFortune",
      ProductTypeModel: "",
      ChartBrandCodeModel: "PHFortune",
      DateRangeModel: null,
      ValueFilterModel: "",
      PropertyFilterModel: "id",
      ConditionFilterModel: "is",
      PropertyFilterList: [
        { text: "transaction id", value: "id" },
        { text: "reference no", value: "reference_no" },
        { text: "merchant id", value: "merchant_id" },
        { text: "User Sitefinity Raffle Id", value: "sitefinity_user_id" },
        { text: "order id", value: "order_id" },
        { text: "product name", value: "catalog_name" },
        { text: "status", value: "status" },
        { text: "win/loss status", value: "winloss_status" },
      ],
      showLoadButton: true,
      timeFilter: [],
      filter: {
        brand_code: "",
        catalog_name: "",
        start_date: "",
        end_date: "",
        gift_status: "",
        id: "",
        merchant_id: "",
        order_id: "",
        product_id: "",
        reference_no: "",
        status: "",
        sitefinity_user_id: "",
        winloss_status: "",
        product_type_id: "",
      },
      allTransaction: [],
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      stockPeriodOption: [
        { text: "Weekly", value: 1 },
        { text: "Monthly", value: 2 },
        { text: "Campaign Period", value: 3 },
      ],
      productTypeOption: [
        { text: "All", value: "" },
        { text: "Normal Item", value: "1" },
        { text: "Bound Item", value: "2" },
      ],
      titlePopup: "Create",
      message: null,
      productModel: {
        id: "",
        brand_code: "",
        product_id: "",
        catalog_name: "",
        merchant_id: "",
        order_id: "",
        reference_no: "",
        winloss_status: "",
        sitefinity_user_id: "",
        status: "",
        gift_status: "",
        expiry_date_time: "",
        credits_used: "",
        credits_balance: "",
        deducted_amount: "",
        urls: "",
        denomination: "",
        product_type_id: "",
        create_date: "",
        modify_date: "",
      },
      showModalCreate: false,
      showModalDetail: false,
      allMerchants: [],
      rows: [],
      columns: [
        {
          label: "Action",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "ID",
          name: "id",
          row_text_alignment: "text-left",
        },
        {
          label: "Ref No",
          name: "reference_no",
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "User Sitefinity Raffle Id",
          name: "sitefinity_user_id",
          sort: true,
        },
        {
          label: "Win/Loss Status",
          name: "winloss_status",
          sort: true,
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Order ID",
          name: "order_id",
          sort: true,
        },
        {
          label: "Product Type",
          name: "product_type_id",
          sort: true,
        },
        {
          label: "Voucher/Product Name",
          name: "catalog_name",
          sort: true,
        },
        {
          label: "Denomination",
          name: "denomination",
          sort: true,
        },
        {
          label: "Reward Status",
          name: "status",
          sort: true,
        },
        {
          label: "Date",
          name: "create_date",
          sort: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 8,
        per_page: this.itemPerPage ? this.itemPerPage : 50,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: true,
        card_mode: false,
        selected_rows_info: true,
        global_search: {
          visibility: false,
        },
        show_refresh_button: false,
        show_reset_button: false,
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    let momNow = this.$moment(new Date().toUTCString());
    let filterEndDate = momNow.format("YYYY-MM-DD");
    let filterStartDate = momNow.add(-1, "months").format("YYYY-MM-DD");
    this.timeFilter.push(filterStartDate);
    this.timeFilter.push(filterEndDate);
    this.filter.start_date = filterStartDate;
    this.filter.end_date = filterEndDate;
    this.DateRangeModel = {
      start_date: filterStartDate,
      end_date: filterEndDate,
    };
    this.onLoadData();
    this.selectedItems.push(this.productModel);
    this.chartDate.push(filterStartDate);
    this.chartDate.push(filterEndDate);
    this.chartInit();
  },
  methods: {
    chartInit() {
      try {
        API.graphql({
          query: queries.listEmsGiftAwayTransactionsSummary,
          variables: {
            brand_code: this.ChartBrandCodeModel,
            start_date: this.chartDate[0],
            end_date: this.chartDate[1],
          },
        }).then((response) => {
          console.log(response);
          var data = response.data.listEmsGiftAwayTransactionsSummary;
          this.SummaryData = data;
          var sourceLabel = [];
          var sourceDataCount = [];
          var sourceDataWin = [];
          var sourceDataLoss = [];
          var sourceDataCredit = [];
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let momDate = this.$moment(element.date);
            let label = momDate.format("YYYY-MM-DD");
            var count = element.count == null ? 0 : element.count;
            var countWin = element.countWin == null ? 0 : element.countWin;
            var countLoss = element.countLoss == null ? 0 : element.countLoss;
            var creditsUsed =
              element.creditsUsed == null ? 0 : element.creditsUsed;
            sourceLabel.push(label);
            sourceDataCount.push(count);
            sourceDataWin.push(countWin);
            sourceDataLoss.push(countLoss);
            sourceDataCredit.push(creditsUsed);
          }

          this.chartDataSource = {
            labels: sourceLabel,
            datasets: [
              {
                label: "Count",
                backgroundColor: "blue",
                data: sourceDataCount,
              },
              {
                label: "Win",
                backgroundColor: "green",
                data: sourceDataWin,
              },
              {
                label: "Loss",
                backgroundColor: "orange",
                data: sourceDataLoss,
              },
            ],
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    arrayPages() {
      var result = [];
      for (let index = 0; index < this.totalPages; index++) {
        result.push({ text: index + 1, value: index + 1 });
      }
      return result;
    },
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('redeemtransaction')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('redeemtransaction')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }

      this.is_allowed_resendorder = this.$store.getters.roleMappingData.some(object =>
        object.function.toLowerCase().includes('resend')
      ) || isAdministrator;
      
    },
    onResetFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        catalog_name: "",
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
        gift_status: "",
        id: "",
        merchant_id: "",
        order_id: "",
        product_id: "",
        reference_no: "",
        status: "",
        sitefinity_user_id: "",
        winloss_status: "",
        product_type_id: this.ProductTypeModel,
      };

      this.onLoadData();
      this.ValueFilterModel = "";
      this.PropertyFilterModel = "id";
      this.ConditionFilterModel = "is";
    },
    onSearchFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        catalog_name: "",
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
        gift_status: "",
        id: "",
        merchant_id: "",
        order_id: "",
        product_id: "",
        reference_no: "",
        status: "",
        sitefinity_user_id: "",
        winloss_status: "",
        product_type_id: this.ProductTypeModel,
      };
      switch (this.PropertyFilterModel) {
        case "id":
          this.filter.id = this.ValueFilterModel;
          break;
        case "reference_no":
          this.filter.reference_no = this.ValueFilterModel;
          break;
        case "merchant_id":
          this.filter.merchant_id = this.ValueFilterModel;
          break;
        case "sitefinity_user_id":
          this.filter.sitefinity_user_id = this.ValueFilterModel;
          break;
        case "order_id":
          this.filter.order_id = this.ValueFilterModel;
          break;
        case "catalog_name":
          this.filter.catalog_name = this.ValueFilterModel;
          break;
        case "status":
          this.filter.status = this.ValueFilterModel;
          break;
        case "winloss_status":
          this.filter.winloss_status = this.ValueFilterModel;
          break;
        case "product_type_id":
          this.filter.product_type_id = this.ValueFilterModel;
          break;
        default:
          break;
      }
      this.onLoadData();
    },
    async onSearchExport() {
      this.onSearchFilter();
      NProgress.start();
      try {
        let response = await API.graphql({
          query: queries.exportEmsGiftAwayTransactions,
          variables: {
            filter: this.filter,
          },
        });
        var presign = response.data.exportEmsGiftAwayTransactions;
        console.log("presign", presign);

        let date_ob = new Date();
        let date = ("0" + date_ob.getDate()).slice(-2);
        let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
        let year = date_ob.getFullYear();
        let minutes = date_ob.getMinutes();
        let second = date_ob.getSeconds();
        var filename= `GiftAwayTransactionReport_${year}-${month}-${date}-${minutes}${second}.csv`;
        
        axios
          .get(presign, { responseType: 'arraybuffer' })
          .then((response) => {
            const a = document.createElement("a");
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            console.log('end download');
          })
          
      } catch (error) {
        console.log(error);
        NProgress.done();
      }
    },
    onDateFilterSubmit(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.filter.start_date = momStart;
      this.filter.end_date = momEnd;
      this.DateRangeModel = {
        start_date: momStart,
        end_date: momEnd,
      };
    },
    onChartDateChanged(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.chartDate.push(momStart);
      this.chartDate.push(momEnd);
      this.chartInit();
    },
    async onLoadData(selectedPage) {
      try {
        var startDate = this.DateRangeModel.start_date + " 00:00:00";
        this.filter.start_date = this.$moment(
          new Date(startDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();
        var endDate = this.DateRangeModel.end_date + " 23:59:59";
        this.filter.end_date = this.$moment(
          new Date(endDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();

        this.filter.brand_code = this.BrandCodeModel;
        this.currentPage = selectedPage ? selectedPage : 1;
        let response = await API.graphql({
          query: queries.listEmsGiftAwayTransactionsPagination,
          variables: {
            pageSize: this.itemPerPage,
            pageNumber: this.currentPage,
            filter: this.filter,
          },
        });
        this.rows = response.data.listEmsGiftAwayTransactionsPagination.items;
        this.totalPages =
          response.data.listEmsGiftAwayTransactionsPagination.totalPages;
        this.totalItems =
          response.data.listEmsGiftAwayTransactionsPagination.totalItems;
        this.allTransaction = this.rows;
      } catch (error) {
        console.log(error);
      }
    },
    onSelectAllRow(payload) {
      this.selectedItems = payload.selected_items;
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      console.log(this.selectedItems);
      if (
        payload.selected_items.length > 1 ||
        payload.selected_items.length == 0
      ) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.productModel = this.allTransaction.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.showModalCreate = true;
      this.titlePopup = "Details";
    },
    resendorder(id, order_id){
      api_loyalty
        .resendorder(this.BrandCodeModel, id, order_id)
        .then((data) => {
          if(data.isSuccess){
            if(data.data.isProcessSuccesfull == true){
              this.message = {
                message: "Resend Order successful.",
                type: "success",
              };
            }else{
              this.message = {
                message: "Resend Order Failed."+ data.data.status,
                type: "danger",
              };
            }
            this.onLoadData();
          }
        })
        .catch((e) => {
          console.log(e);
          this.message = {
            message: "Approve Failed." ,
            type: "danger",
          };
        });
    }
  },
  components: {
    VueBootstrap4Table,
    BarChart,
  },
  watch: {
    PropertyFilterModel: function (val) {
      if (val == "catalog_name" || val == "status") {
        this.ConditionFilterModel = "contains";
        // this.IsConditionFilterDisabled = false;
      } else {
        this.ConditionFilterModel = "is";
        // this.IsConditionFilterDisabled = false;
      }
      console.log(val);
    },
    itemPerPage: function () {
      this.config.per_page = this.itemPerPage;
      this.onLoadData();
    },
    currentPage: function () {
      this.onLoadData(this.currentPage);
    },
    ChartBrandCodeModel: function () {
      this.chartInit();
    },
  },
};
</script>
<style>
.modal-content {
  width: auto;
}
</style>
